import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSmsDripEdition,
    GetSmsDripEditionVariables,
    UpdateSmsDripEdition as UpdateSmsDripEditionMutation,
    UpdateSmsDripEditionVariables as UpdateSmsDripEditionMutationVariables,
    SmsEditionUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_EDITION from '../../graphql/mutations/update-sms-drip-edition.graphql';

import GET_EDITION from '../queries/get-sms-drip-edition.graphql';

export function useUpdateSmsDripEdition(): {
    updateEdition: (arg1: SmsEditionUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateEdition, {loading, error}] = useMutation<
        UpdateSmsDripEditionMutation,
        UpdateSmsDripEditionMutationVariables
    >(UPDATE_EDITION);

    return {
        updateEdition: (input: SmsEditionUpdateInput) =>
            updateEdition({
                variables: {edition: input},
                update: (proxy, mutationResults) => {
                    const updatedEdition = mutationResults.data?.smsEditionUpdate?.edition;

                    if (!updatedEdition) return;

                    const cachedData = proxy.readQuery<
                        GetSmsDripEdition,
                        GetSmsDripEditionVariables
                    >({
                        query: GET_EDITION,
                        variables: {editionId: input.editionId},
                    });

                    if (cachedData?.smsDripEdition) {
                        const cachedEdition = cachedData.smsDripEdition;

                        proxy.writeQuery({
                            query: GET_EDITION,
                            variables: {editionId: input.editionId},
                            data: {
                                smsDripEdition: {
                                    ...cachedEdition,
                                    ...updatedEdition,
                                },
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
